import { render, staticRenderFns } from "./buildinglist.vue?vue&type=template&id=3651e40e&scoped=true&"
import script from "./buildinglist.vue?vue&type=script&lang=js&"
export * from "./buildinglist.vue?vue&type=script&lang=js&"
import style0 from "./buildinglist.vue?vue&type=style&index=0&id=3651e40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3651e40e",
  null
  
)

export default component.exports